import { combineReducers } from "redux";
import entities from "./entities";
import home from "./home";
import app from "./app";
import subjectquery from "./subjectquery";
import majorquery from "./majorquery";
import subject2schoolfilter from "./subject2schoolfilter";
import major2schoolfilter from "./major2schoolfilter";
import schoolfilter from "./schoolfilter";
import intelligentbigdata from "./intelligentbigdata";
import user from "./user";
import active from "./active";
import pay from "./pay";
import trinity from "./trinity";
import trinityResult from "./trinityResult";
import toCollageTool from "./tocollagetool";
//合并成根reducer
const rootReducer = combineReducers({
  entities,
  home,
  app,
  subjectquery,
  subject2schoolfilter,
  major2schoolfilter,
  schoolfilter,
  majorquery,
  intelligentbigdata,
  user,
  active,
  pay,
  trinity,
  trinityResult,
  toCollageTool,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/modules/index.js